import React from "react";

export const normalize = str => (str || "").toLowerCase();

export const escapeRegExp = s => s?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") ?? "";

export const highlightText = (text, term) => {
    if (!term) return text;
    const safeTerm = escapeRegExp(term);
    const regex = new RegExp(`(${safeTerm})`, "gi");
    const parts = String(text ?? "").split(regex);
    const testRegex = new RegExp(`^${safeTerm}$`, "i");
    return parts.map((part, idx) =>
        testRegex.test(part) ? (
            <mark key={idx} className="marketplace-subproduct-highlight">
                {part}
            </mark>
        ) : (
            <span key={idx}>{part}</span>
        )
    );
};
